export default __webpack_public_path__ + "static/media/nextcloud.1cf0dc41.svg";